import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const WorkoutEquipmentTable = props => {
  const { data } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Sort</TableCell>
                  <TableCell>Enable Search</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data && data.map(equipment => (
                  <TableRow className={'table-row'} key={equipment.id} hover>
                    <TableCell>{equipment.id}</TableCell>
                    <TableCell>{equipment.name}</TableCell>
                    <TableCell>{equipment.sort }</TableCell>
                    <TableCell>{equipment.enableSearch ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{equipment.active ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{formatDateTime(equipment.createdAt)}</TableCell>
                    <TableCell>
                      <EditBtn history={props.history} path={`/workout-equipment/edit/${equipment.id}`} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  )
}

export default WorkoutEquipmentTable